module.exports = __webpack_public_path__ + "img/64.79157b19.svg";